export const tableStyles = {
  table: { border: "1px solid #b8b8b8", minWidth: "612px" },
  tableHeaderRow: {
    border: "1px solid #b8b8b8",
    backgroundColor: "#6B7c93",
    color: "#fff",
  },
  tableData: {
    borderRight: "1px solid #b8b8b8",
    textAlign: "center",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    padding: "5px 10px",
    color: "#6B7c93",
  },
  tableBodyRow: {
    backgroundColor: "#f2f3f6",
    borderBottom: "1px solid #b8b8b8",
  },
};



// WEBPACK FOOTER //
// src/layouts/tableStyle.js